import { REFERRAL_HISTORY_FILTER_OPTIONS } from '../../../constants/settings';
import { useReferralHistoryContext } from '../../../contexts/ReferralHistoryProvider';
import FilterButton from '../../CommonComps/Buttons/FilterButton';

const ReferralHistoryFilterActions = () => {
  // integration of context hooks here
  const { referralHistoryType, setReferralHistoryType } =
    useReferralHistoryContext();

  // rendering referral history filter actions component here
  return (
    <div className='grid grid-cols-[repeat(2,_110px)] md:grid-cols-[repeat(2,_120px)]'>
      {REFERRAL_HISTORY_FILTER_OPTIONS.map((option) => (
        <FilterButton
          key={option.id}
          keyId={option.id}
          btnText={option.label}
          color={option.color}
          layoutId='filter-reschedule-underline'
          selectedValue={referralHistoryType}
          onClick={(type) => setReferralHistoryType(type)}
        />
      ))}
    </div>
  );
};

export default ReferralHistoryFilterActions;
